var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#ECECEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1868_941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.238 39.8818V27.5821L15.4235 24.0924L12.0029 22.1559V37.7112C12.0029 38.9122 12.976 39.8818 14.1735 39.8818H19.238Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.602 39.8818H41.6665C42.8676 39.8818 43.8371 38.9086 43.8371 37.7112V22.156L39.9628 24.3741L36.602 27.5821V39.8818Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.238 27.5821L18.7189 22.7763L19.238 18.1766L27.92 24.6882L36.602 18.1766L37.1826 22.528L36.602 27.5821L27.92 34.0937L19.238 27.5821Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.602 18.1766V27.5821L43.8371 22.1559V19.2618C43.8371 16.5777 40.7731 15.0475 38.628 16.6573L36.602 18.1766Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0029 22.156L15.3304 24.6517L19.238 27.5822V18.1767L17.212 16.6573C15.0632 15.0475 12.0029 16.5778 12.0029 19.2618V22.1558V22.156Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1868_941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.84,
    height: 24,
    fill: "white",
    transform: "translate(12 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.cb4b735ae511299fe2df458dc6da2515.svg";
export { ForwardRef as ReactComponent };